import { PRODUCTS } from '#/products/config';
import { isProductDisabledForType } from '#/products/types';
import { State } from '#/unified-rfqs/ui/rfq-builder/store';
import { getSelectableVenues } from '#/unified-rfqs/entities/products/venue';

const venues = getSelectableVenues();

const allOptions = venues.map((p) => ({
  value: p.code,
  label: p.name,
}));

function isVenueDisabledForOb(venueCode: string): boolean {
  const venueProducts = Object.values(PRODUCTS).filter(
    (p) => p.venue === venueCode,
  );
  return (
    venueProducts.length > 0 &&
    venueProducts.every((p) => isProductDisabledForType(p, 'OB'))
  );
}

export default function venueView(
  selectedVenue: State['venue'],
  auction: string | null = null,
) {
  const options =
    auction === 'OB'
      ? allOptions.filter((opt) => !isVenueDisabledForOb(opt.value))
      : allOptions;

  const selectedOption = options.find(
    (option) => option.value === selectedVenue,
  );

  if (selectedOption === undefined)
    throw new TypeError(`Venue with code '${selectedVenue}' doesn't exist.`);

  return { options, selectedOption };
}
